import { Component } from '@angular/core';
import {NgbModal, ModalDismissReasons, NgbModalOptions, NgbActiveModal, NgbNavModule} from '@ng-bootstrap/ng-bootstrap';
// import * as tablePowerExtension from './power-catalog-extension';
import { LocalDataSource } from 'ng2-smart-table';
import { PowerAttributesService} from '../../services/power-attributes.service';
import * as tablePowerCatalogElementExtension from '../power-catalog-element/power-catalog-element-extension';
import * as tablePowerCatalogElementType from '../power-catalog-element/power-catalog-element-type';
import * as tablePowerCatalogElemenAttribute from '../power-catalog-element/power-catalog-element-attribute';
import * as tablePowerCatalogElementPublicNotary from '../power-catalog-element/power-catalog-elemant-public-notary';
import { MifielSignatureService } from 'src/app/services/mifiel-signature.service';
import { ErrorHandlerService } from '../../services/error-handler.service';


@Component({
  selector: 'app-power-catalogs',
  templateUrl: './power-catalogs.component.html',
  styleUrls: ['./power-catalogs.component.css']
})
export class PowerCatalogsComponent {
  // settingsPowerExtension = tablePowerExtension.settingsPowerExtension

  // sourcePowerExtension: LocalDataSource;

  // constructor(private powerAttributeService: PowerAttributesService){}

  powerEnable: boolean = false;
    constructor(private miFielSignatureService: MifielSignatureService
      ,private errorHandler: ErrorHandlerService,
      private uploadService: MifielSignatureService
    ){}

    ngOnInit(): void {
      this.loadCount(localStorage.getItem('userTaxId'));
      this.powerEnable = this.uploadService.getPowersEnabled();
    }
    
  // getPowerExtensions(){
  //   this.powerAttributeService.getAll().
  // }

  settingsPowerCatalogElementExtension = tablePowerCatalogElementExtension.settingsPowerCatalogElementExtension;
  settingsPowerCatalogElementType = tablePowerCatalogElementType.settingsPowerCatalogElementType;
  settingsPowerCatalogElementAttribute = tablePowerCatalogElemenAttribute.settingsPowerCatalogElementAttributes;
  settingsPowerCatalogElemantPublicNotary = tablePowerCatalogElementPublicNotary.settingsPowerCatalogPublicNotary;

  loadCount(userTaxId: string): void {
    // Example of using an HTTP service that might fail
    
    this.miFielSignatureService.getCountByUserTaxId(userTaxId).subscribe({
      next: (data) => {
        console.log('Server Says...');
        console.log(data['thisMonthSignatures'])
      },
      error: (error) => {
        this.errorHandler.checkForError(error,'file-upload -> loadCount');
      }
    });
  }

}
